import { Middleware, Context } from '@nuxt/types';
import getArticlePath from '@root/modules/article/utils/getArticlePath';
import getCategoryPath from '@root/modules/category/utils/getCategoryPath';
import getTagPath from '@root/modules/tags/utils/getTagPath';

const redirectTo = async (pathType: string, context: Context) => {
  let url: string | false = false;

  const { query, route } = context;
  switch (pathType) {
    case 'article':
    case 'articleShortUrl':
      url = await getArticlePath(context);
      break;
    case 'category':
      url = await getCategoryPath(context);
      break;
    case 'topic':
      url = await getTagPath(context);
      break;
  }

  if (url) {
    // build query string
    const queryString = Object.keys(query)
      .map((key) => `${key}=${query[key]}`)
      .join('&');

    if (queryString.length > 0 && url.length > 0) {
      url = `${url}${!url.includes('?') ? '?' : '&'}${queryString}`;
    }

    // Add route hash to the end of path
    url = url.concat(route.hash);

    if (process.client && window.history) {
      window.history.replaceState({}, document.title, document.location.href);
    }
  }
  return url;
};

const pathHandler: Middleware = async (context) => {
  const { route, redirect, app } = context;

  if (process.client) {
    return;
  }

  const redirectPath = route.name && (await redirectTo(route.name, context));

  if (redirectPath) {
    try {
      redirect(301, redirectPath);
    } catch (e) {
      app.$sentry.captureException(`Redirect failed: ${e.message}, original url: ${route.fullPath}, redirect path: ${redirectPath}`, {
        tags: { 'process.server': process.server ? 'server' : 'client' },
      });
      redirect(301, encodeURI(redirectPath));
    }
  }
};

export default pathHandler;
